import { render, staticRenderFns } from "./homeCarousel.vue?vue&type=template&id=0fb6bac4&scoped=true"
import script from "./homeCarousel.vue?vue&type=script&lang=js"
export * from "./homeCarousel.vue?vue&type=script&lang=js"
import style0 from "./homeCarousel.vue?vue&type=style&index=0&id=0fb6bac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb6bac4",
  null
  
)

export default component.exports